export const PoemTimeskip = () => {
    return (
        <div id="052" className="Basic-Text-Frame">
            <p>50 unread messages,</p>
            <p>traffic jam on a global scale,</p>
            <p>we tried killing each other one night</p>
            <p>and ever since then time feels like it's been</p>
            <p>going backwards -</p>
            <p>life looks like photos taken by accident,</p>
            <p>how much of it is just</p>
            <p>replaying the same scene in your head,</p>
            <p>the people on screen and the ones watching</p>
            <p>played by different actors,</p>
            <p>younger counterparts know nothing of</p>
            <p>our newly discovered general apathy,</p>
            <p>they're too busy acting this moment i've been</p>
            <p>unintentionally replaying in my head,</p>
            <p>play, pause, rewind,</p>
            <p>find things that i said back again in my mouth,</p>
            <p>play, pause, rewind,</p>
            <p>it's easy to turn answers back into questions,</p>
            <p>or wish to rewrite the screenplay,</p>
            <p>play, pause, rewind,</p>
            <p>the start and the end,</p>
            <p>and yet the show does inevitably end</p>
            <p>&amp; time continues marching on,</p>
            <br />
            <p>until it gets rebooted</p>
            <p>seven years later,</p>
            <p>
                with a slightly different script &amp; slightly different
                actors,
            </p>
            <p>just the main story beat remains untouched:</p>
            <p>two people try killing each other one night,</p>
            <p>and the 7:51 on my watch</p>
            <p>turns back into a 7:50.</p>
        </div>
    );
};
